import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function Industries() {
  const { t } = useTranslation();
  const items = t('industries.items', { returnObjects: true }) as string[];

  return (
    <section id="industries" className="py-24 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('industries.title')}</h2>
          <p className="text-on-surface-variant max-w-xl mx-auto">{t('industries.subtitle')}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-3"
        >
          {items.map((item, idx) => (
            <span
              key={idx}
              className="px-6 py-3 bg-surface-container-low border border-outline-variant rounded-full text-on-surface font-medium hover:bg-primary-container hover:text-white hover:border-primary-container transition-all cursor-default"
            >
              {item}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
